/** @module Specification/DataPackageCoverSheet */
define([
	"dojo/_base/declare",
	"csi",
	"csi/datasheet/Widget",
	"csi/resolver",
	"csi/xml",
	"csi/xml/Query",
	"Apparel/ProductType"
], function(declare,csi,DataSheetWidget,resolver,xml,Query,ProductType) {
	const viewsMap = new Map([
		["Style", ["ProductSKU", "ProductSKUGallery", "ProductColorGallery", "ProductColors",
			"ProductMaterialColorGalleryForColorAllocation", "ProductMaterialColorsWithColorAllocation",
			"ProductSKUMaterialGalleryWithColorAllocation", "ProductSKUMaterialWithColorAllocation"]],
		["Material", ["ProductSKU", "ProductSKUGallery", "ProductColorGallery", "ProductColors",
			"ProductColorsWithColorAllocation", "ProductColorGalleryForColorAllocation",
			"ProductSKUWithColorAllocation", "ProductSKUGalleryWithColorAllocation"]],
		["Default", ["ProductColorsWithColorAllocation", "ProductColorGalleryForColorAllocation",
			"ProductSKUWithColorAllocation", "ProductSKUGalleryWithColorAllocation",
			"ProductMaterialColorGalleryForColorAllocation", "ProductMaterialColorsWithColorAllocation",
			"ProductSKUMaterialGalleryWithColorAllocation", "ProductSKUMaterialWithColorAllocation"]],
	]);

	return declare(DataSheetWidget, {
		onViewStartBuild() {
			const defView = this.defView;
			const product = this._getProductNode();
			this.omitViewsIds(product, defView);
		},

		/**
		 * Method to determine which views should be removed from the custom view menu.
		 * @param {*} product 
		 * @param {*} defView 
		 */
		omitViewsIds(product, defView) {
			if (product?.ColorAllocationStatus === "ColorAllocationStatus:Allocation WIP") {
				defView.m_defs = defView.m_defs.filter((def) => !viewsMap.get(product.$Type).includes(def.m_id));
			} else {
				defView.m_defs = defView.m_defs.filter((def) => !viewsMap.get("Default").includes(def.m_id));
			}
		},

		getCustomViewNodeContextsStore: function() {
			// summary: return store of product types
			var	node = this._getProductNode();
			// product type may not be valid here, especially if the base isn't a Product
			const prodType = ProductType.type(node);
			return node && prodType ? ProductType.store(prodType) : null;
		},

		_getProductNode: function() {
			// summary: return product containing data package
			return resolver.resolveParent(this.getViewNode());
		},

		_resolveView: function() {
			// summary: assign custom view key
			var	node = this._getProductNode();
			if (node) {
				this.prefKey = this.defView.getKey(node.$Type);
				this.prefNodeContext = ProductType.name(node);
			}

			this.inherited(arguments);
		},

		/**
		 * @override
		 *
		 * C8-16071: If a data package has a ForProductSource set then the Samples, Quotes and SKU Source matrix on the SKU needs to be filtered by supplier.
		 */
		onInsertViewParams: function(defView, node, params) {
			var dataPackage = this.getViewNode();
			if (dataPackage.ForProductSource && dataPackage.ForProductSource != csi.EMPTY_URL){
				if (defView.m_id.startsWith("ProductSamples") || defView.m_id.startsWith("SupplierItems")) {
					var productSource = this.getCache().getNode(dataPackage.ForProductSource);
					var relationship = defView.m_id.endsWith("Gallery") ? defView.m_relationship : defView.m_relationships[0];
					var filters = new Query().RefAttr("Supplier", xml.OP_EQUALS, productSource.Supplier, "Child:__Parent__").getElements();
					if (!relationship.m_filters) {
						relationship.m_filters = filters;
					} else {
						relationship.m_filters.push(filters[0]);
					}
				}
			}
			this.inherited(arguments);
		}
	});
});